import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const swapTestStep = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=swapTestStep&companyid=${user.companyid}&teststepid1=${data.step1Id}&teststepid2=${data.step2Id}&testcaseid=${data.tcid}`,
    {
      step1Id: data.step1Id,
      step2Id: data.step2Id,
      tcid: data.tcid,
    },
  );

  return response.data;
};

const useSwapTestStepMutation = (options = {}) => {
  return useMutation({
    mutationFn: swapTestStep,
    ...options,
  });
};

export default useSwapTestStepMutation;
